import {
  Component,
  OnInit,
  EventEmitter,
  Input,
  Output,
  HostListener,
  ElementRef,
} from '@angular/core';
import { gdprData } from 'src/app/common-class/corp-setting';
import { ParticipationDataService } from 'src/app/_services/participation-data.service';


@Component({
  selector: 'app-gdpr',
  templateUrl: './gdpr.component.html',
  styleUrls: ['./gdpr.component.css'],
})
export class GDPRComponent implements OnInit {
  @Input() Header: string;
  @Input() GDPRData: gdprData;

  @Output() showGDPR: EventEmitter<boolean> = new EventEmitter<boolean>();

  constructor(
    private service: ParticipationDataService,
    private elementref: ElementRef,
  ) {}

  ngOnInit() {}

  Close() {
    this.showGDPR.emit(false);
  }

  CloseKeyboard(event) {
    if (event.keyCode == 13 || event.keyCode == 32) {
      this.Close();
    }
  }

  @HostListener('keydown', ['$event'])
  trapFocus(event: KeyboardEvent) {
    let focusableElements = this.elementref.nativeElement.querySelectorAll(
      'a[href]:not([disabled]), button:not([disabled]),div[role=button]',
    );

    let firstFocusableEl = focusableElements[0];
    let lastFocusableEl = focusableElements[focusableElements.length - 1];

    if (event.keyCode == 9) {
      if (event.shiftKey) {
        /* shift + tab */ if (document.activeElement === firstFocusableEl) {
          lastFocusableEl.focus();
          event.preventDefault();
        }
      } /* tab */ else {
        if (document.activeElement === lastFocusableEl) {
          firstFocusableEl.focus();
          event.preventDefault();
        }
      }
    }
  }
}
